module.exports = __webpack_public_path__ + "img/reduced_about_profile_image.84f1808f.jpg";